import { render, staticRenderFns } from "./ActionCommentConfirm.vue?vue&type=template&id=009f99f5&"
import script from "./ActionCommentConfirm.vue?vue&type=script&lang=ts&"
export * from "./ActionCommentConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports